import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision} from '../../actions/action-creators'
import {State} from '../../reducers'
import {useHistory} from 'react-router'

import DocumentoTributarioV1 from './Components/DetalleDocumento/contents/DocumentoTributarioV1'
import ModalsResumenControlV1 from './Components/ResumenDocumento/ModalsResumenControlV1'
import FooterFinalizacionV1 from './Components/GenerarDocumento/footers/FooterFinalizacionV1'
import { Link } from 'react-router-dom'
import DynamicDetalleContent from './Components/DetalleDocumento/DynamicDetalleContent'

const DetalleDocumento = () => {
  const history = useHistory()
  const {activeDoc} = useSelector((state: State) => state.documentos)

  useEffect(() => {
    if (!activeDoc.idDoc) {
      history.push("/otros-documentos");
    }
  }, []);

  return (
    <>
      <ModalsResumenControlV1 />
      <div className='header-link'>
        <Link to={"/otros-documentos"} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Detalle {activeDoc?.title}</h3>
      </div>
      <div className='separador'></div>
      <div
        id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6'
        className='w-layout-layout bill-section wf-layout-layout'
      >
        <div
          id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6'
          className='w-layout-cell'
          style={{minHeight: '100vh'}}
        >
          <div className='card'>
            <DynamicDetalleContent />
          </div>
        </div>
        <FooterFinalizacionV1 />
      </div>
    </>
  )
}

export default DetalleDocumento
